import * as React from 'react';

import { CustomDialog } from 'components/Dialogs/CustomDialog';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import { AnimatedLoaderModal } from 'components/Loaders/AnimatedLoader';

import styles from './styles.module.scss';

type InputProps = {
  isLoading: boolean;
  isSuccess: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  candidateFullName: string;
  onPurge: () => void;
};

export const ConfirmPurgeDriverDialog = ({
  isLoading = false,
  isSuccess = false,
  open = false,
  setOpen,
  candidateFullName,
  onPurge,
}: InputProps) => {
  return (
    <CustomDialog open={open} setOpen={setOpen} title="Purge Driver?">
      {isLoading ? (
        <AnimatedLoaderModal
          isLoading={!isSuccess}
          classNameWrapper={styles.loaderWrapper}
        />
      ) : (
        <div className={styles.root}>
          <div className={styles.description}>
            Are you sure you want to delete the profile of{' '}
            <b>{candidateFullName}</b>? This action removes all associated
            documents and is not reversible.
          </div>
          <div className={styles.note}>
            Note: All documents are automatically purged 60 days after
            uploading.
          </div>
          <div className={styles.actions}>
            <ButtonWithArrowIcon onClick={onPurge}>Confirm</ButtonWithArrowIcon>
          </div>
        </div>
      )}
    </CustomDialog>
  );
};
